export default () => {
  window.location.href = `${SSO_LOGIN_URL}?DURL=${window.location.href}`;
};
